import React from 'react';
import { BookOpen, Brain, Settings, TrendingUp, Calculator } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
import { motion } from 'framer-motion';
const features = [{
  icon: BookOpen,
  title: 'La Guía Maestra "El Excedente Fantasma"',
  description: 'El paso a paso para identificar y capturar tu fuga de capital.'
}, {
  icon: Brain,
  title: 'El Filtro de Gasto Reaccionario (FGR)',
  description: 'El método mental de 3 segundos para detener compras impulsivas.'
}, {
  icon: Settings,
  title: 'Protocolo de Automatización',
  description: 'Instrucciones exactas para configurar tu "Cobrador Automático" en cualquier banco.'
}, {
  icon: TrendingUp,
  title: 'Hoja de Ruta de Inversión de Bajo Drama',
  description: 'Dónde poner tus primeros $100 para que crezcan con seguridad.'
}, {
  icon: Calculator,
  title: 'Calculadora de Fuga de Capital',
  description: 'Una herramienta simple para ver cuántos años de libertad estás regalando hoy.'
}];
export function WhatYouGet() {
  return <AnimatedSection className="py-24 bg-navy-800 relative px-4 sm:px-6 lg:px-8" data-id="element-153">
      <div className="max-w-5xl mx-auto" data-id="element-154">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-16" data-id="element-155">
          Lo que obtienes hoy
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-156">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-navy-900 border border-navy-700 p-8 rounded-2xl hover:border-gold-400/50 transition-colors group" data-id="element-157">
                <div className="w-12 h-12 bg-navy-800 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-navy-700 group-hover:border-gold-400/30" data-id="element-158">
                  <Icon className="w-6 h-6 text-gold-400" data-id="element-159" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-160">
                  {feature.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-161">
                  {feature.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/10 to-transparent" data-id="element-162" />
    </AnimatedSection>;
}